module.exports = __webpack_public_path__ + "img/dance-test-icon3.5eb868da.png";